import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { FaChevronDown } from "react-icons/fa6";

const AccordianContext = createContext();

export default function Accordian({ children, value, onChange, ...props }) {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    onChange?.(selected);
  }, [selected]);
  return (
    <ul {...props}>
      <AccordianContext.Provider value={{ selected, setSelected }}>
        {children}
      </AccordianContext.Provider>
    </ul>
  );
}

export function AccordianItem({ children, value, trigger, ...props }) {
  const { selected, setSelected } = useContext(AccordianContext);
  const open = selected === value;
  const ref = useRef(null);

  return (
    <li className=" my-4 rounded-md border-b border-[#cfcbcb] py-4" {...props}>
      <header
        role="button"
        onClick={() => setSelected(open ? null : value)}
        className="flex justify-between gap-4 p-2 md:p-4 font-medium text-sm xl:text-base text-text_color"
      >
        <div className="flex justify-start gap-4 ">
          <p>Q.{value}</p>
          <p>{trigger}</p>
        </div>
        <FaChevronDown
          size={16}
          className={`transition-transform ${open ? "rotate-180" : ""}`}
        />
      </header>

      <div
        className="overflow-y-hidden transition-all 3s ease-linear duration-500"
        style={{ height: open ? ref.current?.offsetHeight || 0 : 0 }}
      >
        <div className="px-7 py-2 text-subtext_color" ref={ref}>
          {children}
        </div>
      </div>
    </li>
  );
}
